import { render, staticRenderFns } from "./ScreenImg.vue?vue&type=template&id=2863a642&scoped=true"
import script from "./ScreenImg.vue?vue&type=script&lang=js"
export * from "./ScreenImg.vue?vue&type=script&lang=js"
import style0 from "./ScreenImg.vue?vue&type=style&index=0&id=2863a642&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2863a642",
  null
  
)

export default component.exports